export const httpTypes = {
  HttpService: Symbol.for('MecleeHttpService'),
  ApiUrl: Symbol.for('MecleeHttpApiUrl'),
}
